import type { RuntimeConfig } from '../config';

export const RUNTIME_CONFIG_URL =
  '/stream-annotation-studio/runtime-config.json';

/**
 * Fetches the per-stage runtime config that CDK writes alongside the React bundle.
 * Returns undefined when the file is unreachable (e.g. local dev, Harmony hosting),
 * so callers can fall back to environment-variable / hostname-based stage detection.
 */
export async function fetchRuntimeConfig(): Promise<RuntimeConfig | undefined> {
  try {
    const res = await fetch(RUNTIME_CONFIG_URL, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return (await res.json()) as RuntimeConfig;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(
      'runtime-config.json unavailable; falling back to legacy stage detection',
      err
    );
    return undefined;
  }
}
